import axiosInstance from "../utils/axiosInstance";

export interface MfaSetupResponse {
  provisioningUri: string;
  qrCodeDataUri: string;
  manualEntryKey: string;
}

export interface MfaEnableResponse {
  backupCodes: string[];
}

export interface MfaStatusResponse {
  mfaEnabled: boolean;
  enrolledAt: string | null;
}

export interface MfaVerifyChallengeResponse {
  accessToken: string;
  tokenType: string;
}

export const mfaApi = {
  getStatus: (userId: string) =>
    axiosInstance.get<MfaStatusResponse>(`/api/users/${userId}/mfa/status`),

  setup: (userId: string) =>
    axiosInstance.post<MfaSetupResponse>(`/api/users/${userId}/mfa/setup`),

  enable: (userId: string, code: string) =>
    axiosInstance.post<MfaEnableResponse>(`/api/users/${userId}/mfa/enable`, { code }),

  disable: (userId: string, password: string, code: string) =>
    axiosInstance.post(`/api/users/${userId}/mfa/disable`, { password, code }),

  regenerateBackupCodes: (userId: string, code: string) =>
    axiosInstance.post<MfaEnableResponse>(
      `/api/users/${userId}/mfa/backup-codes/regenerate`,
      { code }
    ),

  // Login-time challenge: no authToken exists in localStorage yet at this
  // point in the flow, so axiosInstance's Authorization interceptor simply
  // won't attach anything - safe to reuse the same client.
  verifyChallenge: (challengeToken: string, code: string) =>
    axiosInstance.post<MfaVerifyChallengeResponse>(`/api/login/mfa/verify`, {
      challengeToken,
      code,
    }),
};
